module.exports = __webpack_public_path__ + "static/media/ImageSymbol_jpg.e6637f0b.jpg";